import React, {useContext, useEffect, useState} from "react";
import {DynamicComponentProps} from "../../core/_models";
import {TextField, Autocomplete, Box} from "@mui/material";

interface OptionProps {
    id: number | string
    name: string
}

export function LookupComponent({config, context}: DynamicComponentProps) {
    const {title, data, id, value, readOnly, onChange: action} = config;

    const [v, setValue] = useState(value);
    const formContext = useContext(context);

    useEffect(() => {
        formContext.set(id, v)
    }, [value])

    const findLabel = (value: string | null): string => {
        if (value == null) {
            return ''
        }

        const intValue = parseInt(value)
        const filtered = data.filter((option: OptionProps) => option.id === intValue)

        if (!filtered.length) {
            return ''
        }

        return filtered[0].name
    }

    return (
        <Autocomplete
            id="country-select-demo"
            options={data.map((option: OptionProps) => option.id)}
            autoHighlight
            getOptionLabel={findLabel}
            disableClearable={true}
            disabled={readOnly}
            onChange={(e, value: string | null) => {
                setValue(value)
                formContext.set(id, value)

                if (action != null) {
                    formContext.submit({action})
                }
            }}
            renderOption={(props, option) => (
                <Box component="li" sx={{'& > img': {mr: 2, flexShrink: 0}}} {...props}>
                    {findLabel(option)}
                </Box>
            )}
            value={v || ''}
            renderInput={(params) => (
                <TextField
                    {...params}
                    size='small'
                    margin="none"
                    fullWidth={true}
                    label={title || 'Select'}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: `autocomplete-${id}`,
                    }}
                    disabled={readOnly}
                />
            )}
        />
    );

    /*return (
        <TextField
            id={id}
            select
            size='small'
            label={title || 'Select'}
            value={v || ''}
            onChange={(e) => {
                setValue(e.target.value)
                formContext.set(id, e.target.value)

                if (action != null) {
                    formContext.submit({action})
                }
            }}
            SelectProps={{
                native: true,
            }}
            margin="none"
            fullWidth={true}
        >
            <option value=''/>
            {(data as OptionProps[]).map(option => (
                <option key={`${title}-${option.id}`} value={option.id}>
                    {option.name}
                </option>
            ))}
        </TextField>
    )*/
}